import { getLocales } from 'assets/locales/Locale';
import AlertBox from 'assets/other/AlertBox';
import { useClaimEdit } from '../ClaimEdit.Hooks';

export default function ClaimEditAlerts() {
  const { lang } = getLocales();
  const { claim } = useClaimEdit();

  return (
    <>
      <h2 style={{ marginTop: 0 }} id="alerts">
        {lang.alertsAndNotifications}
      </h2>
      <AlertBox alerts={claim?.claimAlerts} />
    </>
  );
}
